import React, { useState, useEffect } from "react";
import {
    Container, Grid, Button
} from "@mui/material";
import Title from "../../../components/Title";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import FirtsStep from "../Steps/FirstStep";
import SecondStep from "../Steps/SecondStep";
import ThirdStep from "../Steps/ThirdStep";
import { withRouter } from "react-router-dom";
import * as ROUTES from '../../../constants/routes';
import { useSelector, useDispatch } from "react-redux";
import './Create.css';
import { stepOneValidation, stepSecondValidation } from "./CreateValidation";
import { saveNotification } from "../../../redux/NotificationDuck";
import { useTranslation } from 'react-i18next';

const CreateNotification = props => {
    const { t } = useTranslation(['notification', 'common']);
    const isCreated = useSelector(store => store.notification.isCreated);
    const [step, setStep] = useState(0);
    const [notification, setNotification] = useState({
        title: '', description: '', companyId: '', officeId: '', clientId: '',
        receivers: []
    });
    const [error, setError] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        setNotification({ ...notification, receivers: [] });
        // eslint-disable-next-line
    }, [notification.clientId]);

    const onSubmit = () => {
        dispatch(saveNotification(notification));
    };

    const changeStep = (newStep) => {
        if (step < newStep) {
            if (step === 0) {
                const errorOne = stepOneValidation(notification, t);
                setError(errorOne);
                if (Object.entries(errorOne).length === 0) {
                    setStep(newStep);
                }
            } else if (step === 1) {
                const errorSecond = stepSecondValidation(notification, t);
                setError(errorSecond);
                if (Object.entries(errorSecond).length === 0) {
                    setStep(newStep);
                }
            }
        } else {
            setStep(newStep);
        }
    };

    useEffect(() => {
        (isCreated) && props.history.push(ROUTES.NOTIFICATIONS);
    }, [isCreated, props.history]);

    return (
        <Container>
            <Title title={t("createNotificationBtn")} style={{ marginLeft: 5 }} />
            <Grid item xs={12}>
                <div className="step-container">
                    <Stepper activeStep={step} alternativeLabel>
                        <Step key={'label'}>
                            <StepLabel>{t("subtitle1")}</StepLabel>
                        </Step>
                        <Step key={'label2'}>
                            <StepLabel>{t("subtitle2")}</StepLabel>
                        </Step>
                        <Step key={'label3'}>
                            <StepLabel>{t("subtitle3")}</StepLabel>
                        </Step>
                    </Stepper>
                </div>
                {
                    step === 0 &&
                    <FirtsStep
                        notification={notification}
                        error={error}
                        setValues={setNotification}
                    />
                }
                {
                    step === 1 &&
                    <SecondStep
                        notification={notification}
                        error={error}
                        setValues={setNotification}
                    />
                }
                {
                    step === 2 &&
                    <ThirdStep
                        notification={notification}
                        setStep={changeStep}
                    />
                }
                <div style={{ display: 'flex' }}>
                    {step > 0 &&
                        <Button variant="contained" className="button-app-previous" style={{ marginRight: 24 }}
                            onClick={() => changeStep(step - 1)}>
                            {t("common:commonPreviousLbl")}
                        </Button>
                    }
                    {step < 2
                        ?
                        <Button variant="contained" className="button-app-save"
                            onClick={() => changeStep(step + 1)}>
                            {t("common:commonNextLbl")}
                        </Button>
                        :
                        <Button variant="contained" className="button-app-save"
                            onClick={() => onSubmit()}>
                            {t("sendNotificationBtn")}
                        </Button>
                    }
                </div>
            </Grid>
        </Container>
    );
}
export default withRouter(CreateNotification);